import "./dropdown.scss";
import classNames from "classnames";
import { Icon } from "@/elements/icon/icon";
import { Text } from "@/elements/text/text";
import { type ReactElement } from "react";

interface PProps {
  id: string;
  label?: string;
  value?: string;
  options: Array<{ value: string; label: string }>;
  block?: boolean;
  onChange: (value: string) => void;
}

export function Dropdown({
  id,
  label,
  value,
  options,
  block,
  onChange,
}: PProps): ReactElement {
  const optionsToDisplay = [
    ...(label
      ? [
          {
            label,
            value: "",
          },
        ]
      : []),
    ...options,
  ];

  return (
    <div className={classNames("dropdown", { "dropdown--block": block })}>
      <Text type="button" color="primary-on-default">
        <select
          id={id}
          className="dropdown__input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {optionsToDisplay.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </Text>
      <span className="dropdown__icon">
        <Icon name="chevron-down" size={24} color="accent-tinted" />
      </span>
    </div>
  );
}
